import React from 'react';
import { Faq, Question } from '@luckycart/xpn-types';
import parse from 'html-react-parser';

import { FaqTitle, StyledCollapse, StyledPanel, StyledUpOutlined } from './Faq.style';

export type FaqProps = { faq: Faq | undefined};

const AppFaq: React.FC<FaqProps> = (props: FaqProps) => {
  const questions = props.faq?.questions.map((question: Question, index: number) => {
    // eslint-disable-next-line react/no-array-index-key
    return <StyledPanel header={question.question} key={index + 1}>
      <p>{parse(question.answer)}</p>
    </StyledPanel>;
  });
  return <>
    <FaqTitle>{props.faq?.title}</FaqTitle>
    <StyledCollapse accordion
      bordered={false}
      expandIconPosition="end"
      expandIcon={({ isActive }) => <div><StyledUpOutlined rotate={isActive === true
        ? 0
        : 180} /></div> }
      className="site-collapse-custom-collapse"
    >
      {questions}
    </StyledCollapse>

  </>;

};
export default AppFaq;
